<template>
  <!-- v-if="evaluateList.length" -->
  <div :class="_.block">
    <div :class="_.list">
      <img
        v-for="(item, index) in data"
        :key="index"
        :class="_.img"
        :src="item.icon"
        @click="handleClick(item)"
      />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    data() {
      return {}
    },
    methods: {
      handleClick(item) {
        this.$dcb.navigateTo({
          url: item.targetUrl,
        })
      },
    },
  })
</script>

<style lang="scss" module="_">
  // 之前单个img的写法可能受父级 flex: 1 影响图片在ios16以下版本会出问题
  .block {
    font-size: 0;

    .list {
      // padding: 20px;
      .img {
        width: 100%;
        margin-bottom: 12px;
        vertical-align: middle;
      }
    }
  }
</style>
